import { DEFAULT_ASSET_CONFIG_RATIO_4_1 } from "./constants";
import { AssetConfig } from "./types";

export enum ImageAspectRatio {
  RATIO_4_1 = "RATIO_4_1"
}

export const ImageAspectRatioToDimension: Record<string, AssetConfig> = {
  [ImageAspectRatio.RATIO_4_1]: DEFAULT_ASSET_CONFIG_RATIO_4_1
};
